export const PROJECT = process.env.REACT_APP_PROJECT;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

export const RECENT_SEARCHES_KEY = "savedSearchQueries";
export const RECENT_POIS_KEY = "savedPoiQueries";
export const FALLBACK_LANGUAGE = "en-GB";
